import { CreateMediaRequest, createMedia } from '../services';

import { UploadProgressEvent } from '../ui';

const uploadFile = async (file: CreateMediaRequest, onProgress?: (event: UploadProgressEvent) => void) => {
  return createMedia(file, onProgress);
};

export default uploadFile;
